import Tracker from "./tracker";
class NullTracker extends Tracker {
  init() {}
}

export default NullTracker;
